import axios from "axios";
import AppConfig from "../../AppConfig";

const sendLogout = async function (username,password) {
    let res=false;
    try {
        let query='{logout}';
        let data={  query: query,variables: null, operationName: null  };
        let url=AppConfig.base_url+ '/graphql/auth/member';
        let config = {
            withCredentials: true,
        };
        let response = await  axios.post(url,data,config);
        if ( response.hasOwnProperty("data")){
            if ( response.data.hasOwnProperty("data")) {
                let data = response.data.data;
                if (data.hasOwnProperty("logout")) {
                    if (data.logout === true || data.logout === "true") res = true;
                }
            }
        }
    } catch (error) {
        res = false;
    }
    return res;
};

export default async function logout() {
    return await sendLogout();
}
